export default {
	setProduct: 'SET_PRODUCT',
	error: 'ERROR_PRODUCT',
	loading: 'LOADING_PRODUCT',
};
